import axios from 'axios';
import Web3 from 'web3';

const API_URL = process.env.REACT_APP_EARTH_RPC_URL || 'https://main-rpc.earth.ooo';
const web3 = new Web3(new Web3.providers.HttpProvider(API_URL));

export const apiGet = async (method, params = []) => {
  try {
    const response = await axios.post(API_URL, {
      jsonrpc: '2.0',
      id: 1,
      method,
      params
    });
    console.log('API Response:', response.data);
    if (response.data.result) {
      return response.data.result;
    } else {
      throw new Error(response.data.error ? response.data.error.message : 'API request failed');
    }
  } catch (error) {
    console.error(`Error in ${method}:`, error.message);
    throw error;
  }
};

export async function getAccountBalance(address) {
  try {
    const balance = await web3.eth.getBalance(address);
    return web3.utils.fromWei(balance, 'ether');
  } catch (error) {
    console.error('Failed to get account balance:', error);
    return '0';
  }
}

export async function getLatestBlockNumber() {
  try {
    return await web3.eth.getBlockNumber();
  } catch (error) {
    console.error('Failed to get latest block number:', error);
    return null;
  }
}

export async function getGasPrice() {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    return web3.utils.fromWei(gasPrice, 'gwei');
  } catch (error) {
    console.error('Failed to get gas price:', error);
    return null;
  }
}

export async function getTokenBalance(address, contractAddress) {
  // This function might need to be implemented differently depending on the Earth network's support for ERC20 tokens
  console.warn('getTokenBalance function needs to be implemented');
  return '0';
}